<template>
	<div>
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="subTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-row>
					<v-col cols="8">
						<v-select
							hide-details
							:items="confirmation_types"
							v-model="pattern"
							item-text="text"
							item-value="value"
							dense
							outlined
							background-color="white"
							@change="fetchRequirements($route.query.page ? $route.query.page : 1)"
						/>
					</v-col>
				</v-row>
				<RequirementSearchDialog
					text
					ref="search"
					:statusIdsHash="statusIdsHash"
					:requirementTypes="typesForSearch"
					:confirmationFlag="true"
					@setSearchedList="setSearchedList"
					:departmentId="$route.params['id']"
				/>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-select
					class="mb-2"
					:items="approval_types"
					item-text="text"
					item-value="value"
					dense
					outlined
					v-model="pattern"
					hide-details
					background-color="white"
				/>

				<RequirementSearchDialog
					ref="search"
					:statusIdsHash="statusIdsHash"
					:requirementTypes="typesForSearch"
					:confirmationFlag="true"
					:userList="userList"
					@setSearchedList="setSearchedList"
				/>
			</template>

			<div class="table-container px-2 mt-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="requirements"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="未確認依頼はありません。"
				>
					<template v-slot:item="{ item }">
						<tr height="60px">
							<template v-if="authority_flag">
								<td>
									<template v-if="item.status_id == 'waiting_confirmation'">
										<v-btn class="ma-1" dense dark color="secondary" @click="openConfirm(item)">
											<v-icon class="mr-1">mdi-clipboard-check-outline</v-icon> 発行確認
										</v-btn>
									</template>
									<template v-if="item.answer && item.answer.status_id == 'waiting_confirmation'">
										<v-btn
											class="ma-1"
											dense
											dark
											color="secondary"
											@click="openAnswerConfirm(item)"
											><v-icon class="mr-1">mdi-clipboard-check-outline</v-icon> 回答確認
										</v-btn>
									</template>
									<p v-if="item.status_id == 'waiting_approval'">発行確認済み</p>
									<p v-if="item.answer && item.answer.status_id == 'waiting_approval'">
										回答確認済み
									</p>
									<p v-if="item.status_id == 'sent' && !item.answer">発行済み</p>
									<p v-if="item.answer && item.answer.status_id == 'sent'">回答済み</p>
								</td>
								<td>
									<v-btn
										v-if="item.status_id == 'waiting_confirmation'"
										class="ma-1"
										dense
										dark
										color="red"
										@click="openRefuseDialog(item, 'requirement')"
										><v-icon class="mr-1">mdi-hand-back-left-off-outline</v-icon> 差戻す
									</v-btn>
									<v-btn
										v-if="item.answer && item.answer.status_id == 'waiting_confirmation'"
										class="ma-1"
										dense
										dark
										color="red"
										@click="openRefuseDialog(item, 'answer')"
										><v-icon class="mr-1">mdi-hand-back-left-off-outline</v-icon> 差戻す
									</v-btn>
									<p v-if="item.status_id == 'refused'">差戻し済み</p>
									<p v-if="item.answer && item.answer.status_id == 'refused'">差戻し済み</p>
								</td>
							</template>
							<td @click="showDialog(item.id, 1)">{{ item.user.full_name }}</td>
							<td @click="showDialog(item.id, 1)">{{ item.requirement_type.name }}</td>
							<td @click="showDialog(item.id, 1)">{{ common.formatDate(item.deadline) }}</td>
							<td @click="showDialog(item.id, 1)">
								<span v-if="item.matter">{{ item.matter.name }}</span>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<RequirementConfirm
			ref="confirm"
			:confirmPackage="confirmPackage"
			:confirmationFlag="true"
			@confirmRequirement="confirmRequirement"
		></RequirementConfirm>
		<AnswerConfirm
			ref="answer_confirm"
			:answerConfirmationFlag="true"
			@confirmAnswer="confirmAnswer"
		/>
		<RequirementShowDialog
			ref="show"
			@reloadIndex="reloadList"
			@update-requirement="updateRequirement($event)"
		/>
		<RefuseMessageDialog
			ref="refuse"
			:department_id="id"
			@refuseRequirement="refuseRequirement"
			@refuseAnswer="refuseAnswer"
		/>
	</div>
</template>

<script>
import axios from "axios"
import common from "../../helper/common"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import RequirementShowDialog from "./components/RequirementInfoDialog.vue"
import RequirementSearchDialog from "./components/RequirementSearchDialog.vue"
import RequirementConfirm from "./components/RequirementConfirm.vue"
import RefuseMessageDialog from "./components/RefuseMessageDialog.vue"
import AnswerConfirm from "../answers/components/AnswerConfirm.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		PaginationModule,
		TemplateDeleteDialog,
		RequirementShowDialog,
		RequirementSearchDialog,
		RequirementConfirm,
		RefuseMessageDialog,
		AnswerConfirm,
	},
	data() {
		return {
			confirmPackage: {},
			user: {},
			userList: [],
			requirementTypes: [],
			typesForSearch: [],
			statusIdsHash: {},
			id: this.$route.params["id"],
			mainTitle: "依頼確認",
			subTitle: "確認前依頼一覧",
			confirmation_types: [
				{ text: "発行未確認依頼", value: "pre_confirmation_requirement" },
				{ text: "回答未確認依頼", value: "pre_confirmation_answer" },
			],
			requirements: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			authority_flag: false,
			confirmationFlag: false,
			searchedFlag: false,
			common,
			pattern: "pre_confirmation_requirement",
		}
	},

	created() {
		authenticate.authenticateUser()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchRequirements(page)
	},

	methods: {
		fetchRequirements(page) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/departments/${this.id}/requirement_confirmation`, {
					params: { page: page, pattern: this.pattern },
					headers,
				})
				.then((res) => {
					this.pagination = res.data.pagination
					this.requirements = res.data.requirements
					this.authority_flag = res.data.authority_flag
					this.user = res.data.user
					this.statusIdsHash = res.data.status_ids_hash
					this.typesForSearch = res.data.department_requirement_types
					this.requirementTypes = res.data.requirement_types
					this.userList = res.data.department_users
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		getPage(page) {
			this.fetchRequirements(page)
		},

		confirmRequirement(requirement_id) {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/departments/${this.id}/requirement_confirmation/${requirement_id}`,
					{ requirement_confirmation: { requirement_id } },
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "依頼発行を確認しました",
						type: "notice",
					})
					const status = res.data.status_id
					let requirement = this.requirements.find((r) => r.id == requirement_id)
					const index = this.requirements.indexOf(requirement)
					requirement.status_id = status
					this.requirements[index] = requirement
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmAnswer(requirement_id) {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/departments/${this.id}/answer_confirmation/${requirement_id}`,
					{ answer_confirmation: { requirement_id } },
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "依頼回答を確認しました",
						type: "notice",
					})
					const status = res.data
					let requirement = this.requirements.find((r) => r.id == requirement_id)
					const index = this.requirements.indexOf(requirement)
					requirement.answer.status_id = status
					this.requirements[index] = requirement
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		refuseRequirement(
			requirement_id,
			message,
			requirement_type_id,
			matter_id,
			requirement_user_id
		) {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/departments/${this.id}/requirement_confirmation/${requirement_id}`,
					{
						requirement_confirmation: {
							message,
							requirement_type_id,
							matter_id,
							requirement_user_id,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "差戻しました",
						type: "notice",
					})
					const status = res.data.status_id
					let requirement = this.requirements.find((r) => r.id == requirement_id)
					const index = this.requirements.indexOf(requirement)
					requirement.status_id = status
					this.requirements[index] = requirement
					this.$refs.refuse.close()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		refuseAnswer(requirement_id, message, requirement_type_id, matter_id, answer_user_id) {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/departments/${this.id}/answer_confirmation/${requirement_id}`,
					{
						answer_confirmation: {
							message,
							requirement_type_id,
							matter_id,
							answer_user_id,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "差戻しました",
						type: "notice",
					})
					const status = res.data
					let requirement = this.requirements.find((r) => r.id == requirement_id)
					const index = this.requirements.indexOf(requirement)
					requirement.answer.status_id = status
					this.requirements[index] = requirement
					this.$refs.refuse.close()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		showDialog(id, index) {
			this.$refs.show.openDialog(id, index)
		},

		setSearchedList(requirements) {
			this.searchedFlag = true
			this.requirements = requirements
		},

		reloadList() {
			this.fetchRequirements(pagination.current)
		},
		updateRequirement(requirement) {
			const oldRequirement = this.requirements.find((r) => r.id == requirement.id)
			const index = this.requirements.indexOf(oldRequirement)
			this.$set(this.requirements, index, requirement)
		},

		openConfirm(requirement) {
			let confirmPackage = {
				requirement: requirement,
				values: requirement.requirement_values,
				user: this.user,
				matter: requirement.matter,
				selectedType: requirement.requirement_type,
			}
			if (requirement.matter_product_id)
				confirmPackage.matterProduct = {
					name: common.matterProductByRequirement(requirement),
				}
			if (requirement.ordered_product_id)
				confirmPackage.orderedProduct = {
					name: common.orderedProductByRequirement(requirement),
				}
			if (requirement.order_individual_info_id)
				confirmPackage.orderIndividualInfo = {
					name: common.orderIndividualInfoByRequirement(requirement),
				}
			this.confirmPackage = confirmPackage
			this.$refs.confirm.openDialog()
		},
		openAnswerConfirm(dataSet) {
			const answer_values = dataSet.answer.answer_values
			const answer = dataSet.answer
			const values = answer_values
			const requirement = dataSet
			const template = dataSet.answer.answer_template

			this.$refs.answer_confirm.openDialog(answer, values, requirement, template)
		},
		openRefuseDialog(requirement, status) {
			this.$refs.refuse.openDialog(requirement, status)
		},
	},
	computed: {
		headers() {
			return this.authority_flag
				? [
						{ text: "", value: "", width: "200px" },
						{ text: "", value: "", width: "200px" },
						{ text: "依頼者", value: "user_name", width: "250px" },
						{ text: "依頼の種類", value: "requirement_type_name", width: "250px" },
						{ text: "依頼納期", value: "deadline", width: "150px" },
						{ text: "案件", value: "matter_name", width: "150px" },
				  ]
				: [
						{ text: "依頼者", value: "user_name", width: "250px" },
						{ text: "依頼の種類", value: "requirement_type_name", width: "250px" },
						{ text: "依頼納期", value: "deadline", width: "150px" },
						{ text: "案件", value: "matter_name", width: "150px" },
				  ]
		},
	},
}
</script>
